import usePastPerformanceCalculationStatus from './usePastPerformanceCalculationStatus';
import { InlineLoader } from 'components/shared/';

import { ReportCalculationWrapper } from './ReportCalculationStatus.styles';

const ReportCalculationStatus = () => {
  const reportCalculationStatus = usePastPerformanceCalculationStatus();

  if (reportCalculationStatus === 'complete') {
    return null;
  }

  return (
    <ReportCalculationWrapper>
      <InlineLoader /> Updating your reports
    </ReportCalculationWrapper>
  );
};

export default ReportCalculationStatus;
